import React, { useState, useEffect } from "react";
import MainPart from "./partsOfGame/MainPart/MainPart";
import FirstPart from "./partsOfGame/FirstPart/FirstPart";
import SecondPart from "./partsOfGame/SecondPart/SecondPart";
import ThirdPart from "./partsOfGame/ThirdPart/ThirdPart";
import FourthPart from "./partsOfGame/FourthPart/FourthPart";
import GiftPart from "./partsOfGame/GiftPart/GiftPart";
import closeIcon from "./assets/images/slides/closeIcon.png";
import Navbar from "./components/Navbar/Navbar";
import Background from "./components/Background/Backgorund";
import ContentContainer from "./components/ContentContainer/ContentContainer";
import VideoComponent from "./components/VideoComponent/VideoComponent";
import watchVideos from "./assets/images/slides/watchVideos.png";
import claimStickers from "./assets/images/slides/claimStickers.png";
import downloadStickers from "./assets/images/slides/downloadStickers.png";
import closeInfo from "./assets/images/slides/closeInfo.png";
import Dialog from "./components/Dialog/Dialog";
import allContent from "./allContent";

import useLocalStorageState from "use-local-storage-state";

function App() {
  const [phase, setPhase] = useState(0.0);
  const [videoPhaseFirstWeek, setVideoPhaseFirstWeek] = useState(0);
  const [videosWatchedFirstWeek, setVideosWatchedFirstWeek] = useState(0);
  const [videoPhaseSecondWeek, setVideoPhaseSecondWeek] = useState(0);
  const [videosWatchedSecondWeek, setVideosWatchedSecondWeek] = useState(0);
  const [videoPhaseThirdWeek, setVideoPhaseThirdWeek] = useState(0);
  const [videosWatchedThirdWeek, setVideosWatchedThirdWeek] = useState(0);
  const [videoPhaseFourthWeek, setVideoPhaseFourthWeek] = useState(0);
  const [videosWatchedFourthWeek, setVideosWatchedFourthWeek] = useState(0);
  const [infoPop, setInfoPop] = useState(0);

  const [seen1, setSeen1] = useLocalStorageState("seen1", false);
  const [seen2, setSeen2] = useLocalStorageState("seen2", false);
  const [seen3, setSeen3] = useLocalStorageState("seen3", false);
  const [seen4, setSeen4] = useLocalStorageState("seen4", false);
  const [seen5, setSeen5] = useLocalStorageState("seen5", false);
  const [seen6, setSeen6] = useLocalStorageState("seen6", false);
  const [seen7, setSeen7] = useLocalStorageState("seen7", false);

  const [seenAll, setSeenAll] = useLocalStorageState("seenAll", false);

  const timestamps = allContent.timestamps;

  // converts today in timestamp
  const today = new Date().getTime();

  useEffect(() => {
    if (seen1 && seen2 && seen3 && seen4 && seen5 && seen6 && seen7) {
      setSeenAll(true);
    }
  }, [seen1, seen2, seen3, seen4, seen5, seen6, seen7]);

  const [openVideo, setOpenVideo] = useState(false);
  const [video, setVideo] = useState(null);

  const [showDialog, setShowDialog] = useState(false);
  const [dialogContent, setDialogContent] = useState(null);

  const [buttonBottom, setButtonBottom] = useState(586);

  return (
    <div className="applicationHolder">
      <div className="mobileVersion">
        <Navbar phase={phase} setPhase={setPhase} setOpenVideo={setOpenVideo} />
        <Background
          phase={phase}
          setPhase={setPhase}
          setButtonBottom={setButtonBottom}
        />
        <ContentContainer
          phase={phase}
          setPhase={setPhase}
          setOpenVideo={setOpenVideo}
          setVideo={setVideo}
          setShowDialog={setShowDialog}
          setDialogContent={setDialogContent}
          timestamps={timestamps}
          buttonBottom={buttonBottom}
        />

        {openVideo && (
          <VideoComponent video={video} setOpenVideo={setOpenVideo} />
        )}
        {showDialog && (
          <Dialog setShowDialog={setShowDialog} dialogContent={dialogContent} />
        )}
      </div>
      <div className="masterContainer">
        <MainPart
          setInfoPop={setInfoPop}
          phase={phase}
          setPhase={setPhase}
          allContent={allContent}
        />
        <FirstPart
          phase={phase}
          setPhase={setPhase}
          videoPhaseFirstWeek={videoPhaseFirstWeek}
          setVideoPhaseFirstWeek={setVideoPhaseFirstWeek}
          videosWatchedFirstWeek={videosWatchedFirstWeek}
          seen1={seen1}
          seen2={seen2}
          setShowDialog={setShowDialog}
          setDialogContent={setDialogContent}
          allContent={allContent}
        />
        <SecondPart
          phase={phase}
          setPhase={setPhase}
          videoPhaseSecondWeek={videoPhaseSecondWeek}
          setVideoPhaseSecondWeek={setVideoPhaseSecondWeek}
          videosWatchedSecondWeek={videosWatchedSecondWeek}
          videosWatchedFirstWeek={videosWatchedFirstWeek}
          seen1={seen1}
          seen2={seen2}
          seen3={seen3}
          seen4={seen4}
          timestamps={timestamps}
          today={today}
          setShowDialog={setShowDialog}
          setDialogContent={setDialogContent}
          allContent={allContent}
        />
        <ThirdPart
          phase={phase}
          setPhase={setPhase}
          videoPhaseThirdWeek={videoPhaseThirdWeek}
          setVideoPhaseThirdWeek={setVideoPhaseThirdWeek}
          videosWatchedThirdWeek={videosWatchedThirdWeek}
          videosWatchedSecondWeek={videosWatchedSecondWeek}
          seen1={seen1}
          seen2={seen2}
          seen3={seen3}
          seen4={seen4}
          seen5={seen5}
          seen6={seen6}
          timestamps={timestamps}
          today={today}
          setShowDialog={setShowDialog}
          setDialogContent={setDialogContent}
          allContent={allContent}
        />
        <FourthPart
          phase={phase}
          setPhase={setPhase}
          videoPhaseFourthWeek={videoPhaseFourthWeek}
          setVideoPhaseFourthWeek={setVideoPhaseFourthWeek}
          videosWatchedFourthWeek={videosWatchedFourthWeek}
          videosWatchedThirdWeek={videosWatchedThirdWeek}
          seen1={seen1}
          seen2={seen2}
          seen3={seen3}
          seen4={seen4}
          seen5={seen5}
          seen6={seen6}
          seen7={seen7}
          timestamps={timestamps}
          today={today}
          setShowDialog={setShowDialog}
          setDialogContent={setDialogContent}
          allContent={allContent}
        />
        <GiftPart
          phase={phase}
          setPhase={setPhase}
          videosWatchedFirstWeek={videosWatchedFirstWeek}
          videosWatchedSecondWeek={videosWatchedSecondWeek}
          videosWatchedThirdWeek={videosWatchedThirdWeek}
          videosWatchedFourthWeek={videosWatchedFourthWeek}
          seenAll={seenAll}
          allContent={allContent}
        />
        {showDialog && (
          <Dialog setShowDialog={setShowDialog} dialogContent={dialogContent} />
        )}
      </div>

      {videoPhaseFirstWeek === 1 && (
        <div className="videoHolder1">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week1.video1}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseFirstWeek(0);
                setVideosWatchedFirstWeek(videosWatchedFirstWeek + 1);
                setSeen1(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseFirstWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {videoPhaseFirstWeek === 2 && (
        <div className="videoHolder2">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week1.video2}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseFirstWeek(0);
                setVideosWatchedFirstWeek(videosWatchedFirstWeek + 1);
                setSeen2(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseFirstWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {videoPhaseSecondWeek === 1 && (
        <div className="videoHolder3">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week2.video1}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseSecondWeek(0);
                setVideosWatchedSecondWeek(videosWatchedSecondWeek + 1);
                setSeen3(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseSecondWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {videoPhaseSecondWeek === 2 && (
        <div className="videoHolder4">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week2.video2}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseSecondWeek(0);
                setVideosWatchedSecondWeek(videosWatchedSecondWeek + 1);
                setSeen4(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseSecondWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {videoPhaseThirdWeek === 1 && (
        <div className="videoHolder5">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week3.video1}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseThirdWeek(0);
                setVideosWatchedThirdWeek(videosWatchedThirdWeek + 1);
                setSeen5(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseThirdWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {videoPhaseThirdWeek === 2 && (
        <div className="videoHolder6">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week3.video2}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseThirdWeek(0);
                setVideosWatchedThirdWeek(videosWatchedThirdWeek + 1);
                setSeen6(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseThirdWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {videoPhaseFourthWeek === 1 && (
        <div className="videoHolder7">
          <div className="wholeVideo">
            <video
              controlsList="nodownload"
              className="videoPlayer"
              src={allContent.week4.video1}
              autoPlay
              controls
              onEnded={() => {
                setVideoPhaseFourthWeek(0);
                setVideosWatchedFourthWeek(videosWatchedFourthWeek + 1);
                setSeen7(true);
              }}
            ></video>
            <img
              onClick={() => {
                setVideoPhaseFourthWeek(0);
              }}
              className="closeIcon"
              src={closeIcon}
              alt="close"
            />
          </div>
        </div>
      )}

      {infoPop === 1 && (
        <div className="infoPopUp">
          <div className="infoPopUpWrap">
            <div className="iconAndText">
              <img src={watchVideos} alt="watchVideos" />
              <p>
                {allContent.infoWindow.watch.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>
            <div className="iconAndText">
              <img src={claimStickers} alt="claimStickers" />
              <p>
                {allContent.infoWindow.claim.split("\n").map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </p>
            </div>
            <div className="iconAndText">
              <img src={downloadStickers} alt="downloadStickers" />
              <p>{allContent.infoWindow.download}</p>
            </div>
            <img
              onClick={() => {
                setInfoPop(0);
              }}
              className="closeInfo"
              src={closeInfo}
              alt="closeInfo"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
